/* lua.js generated code 0.3.0 */

let BaseHomeScene = require("clover/scene/BaseHomeScene")
let MiniHomeScene = xClass("MiniHomeScene", BaseHomeScene)
let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager")
let ButtonPushBounceIdleBubbleAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceIdleBubbleAnim")
let MiniSceneAnim = require("clover/scene/component/homescene/homeSceneAnim/MiniSceneAnim")
let NewIntroNode =  require("clover/scene/component/NewIntro/NewIntroNode")
let IslandItemNode2 = require("clover/scene/component/IslandsSystem/IslandItemNode2")
let ContinueCheckManager = require("clover/scene/component/homescene/ContinueCheckManager")
// let GoldTurnLogic = require("activity/GoldTurn/GoldTurnLogic");
let AIPkgManager = require("activity/AIPackage/AIPkgManager");
const WelfareCenterLogic = require("../../activity/WelfareCenter/WelfareCenterLogic")


MiniHomeSceneLayerDef = {
    kLights: -5,
    kBirds: -8,
    kFishs: -1,
    kIslands: -9,
    kStartBtn: -7,
    kShip: -3,
    kTargetsNode: -2,
    kStarChest: 1,
    kChestBubble: 2,    
    kAddMine: 5,
    kPosC: 16, // C位按键，在开始按键的左侧
}
MiniHomeScene.create = function (isMainHome) {
    let s = MiniHomeScene.new()
    s.name = "HomeScene"
    s.isMainHome = isMainHome
    s.initScene()
    
    // if (META.platform === XcloverPlatform.wechatgame && !_G.kIsNewUser) {
    //     let MpPlugin = require('platform/wechatgame/mgplugin')
    //     global.MpPluginInstance = new MpPlugin.RecommendUI({
    //         appid: "wxd93fb8bddf971d14",
    //         openid: META.user.openid,
    //     })
    //     MpPlugin.enterReport("wxd93fb8bddf971d14", META.user.openid)
    // }
    return s
}
MiniHomeScene.prototype.onInit = function () {
    let self = this
    BaseHomeScene.prototype.onInit.call(this)
    WelfareCenterLogic.onGlobalEvent();
    self.buildStartBtn()

    // self.buildIsland()
    self.buildMiniSceneAnim()
    self.buildTargets()
    // self.buildBubugTools()
    // self.updateFriendPvp()
    // self.playNormalStartBtnAnim()

    // 通用的持续查询
    ContinueCheckManager.getInstance().init();
    // 精力广告
    AdEnergyManager.getInstance().init(self.getInfoBanner());
    // pvp过期奖励检查
    self.pvpCheckRewardExpire();
    // 格子广告插屏广告用查询
    self.adCheckCondition();
    // 初始化新手奖励
    NoviceGiftManager.getInstance()

    // 上次的登录时间，插屏广告用
    cc.log("!!!!lastLoginSec!!!!", Localhost.timeInSec());
    var lastLoginSec = UserManager.getInstance().lastLoginSec;
    if (lastLoginSec != 0){
        lastLoginSec = Localhost.timeInSec() - lastLoginSec;
    }
    UserManager.getInstance().lastLoginSec = lastLoginSec;

    // 星星抽奖
    self.checkLastStarDrawReward();

    if (__DEBUG || isWechatGameEnv()){
        self.checkWechatGift()
    }
    
    if (window.mini && !mini.supportAutoUpdate()){
        //let hostQuery = getParameterByName("_qamode")
        //stage 环境不更新
        if (HTTP_HOST_QUERY != "env=qa"){
            mini.forceUpdate()
        }
    }



    // 设置屏幕常亮
    if (global.mini && mini.getPlatform() === MiniPlatform.wechatGame){
        cc.log("[屏幕常亮] MiniHomeScene onInit cc.sys.os",cc.sys.os);
        if (cc.sys.os === cc.sys.OS_IOS) {
            wx.getSystemInfo({
                success (res) {
                console.log("[屏幕常亮] MiniHomeScene onInit res.system",res.system);
                let str = res.system;
                let strArr = str.split(" ");
                let sys_code = strArr[1].split(".")[0];
                cc.log("[屏幕常亮] MiniHomeScene onInit sys_code",sys_code);
                if (Number(sys_code) >= 12){      
                    cc.log("[屏幕常亮] MiniHomeScene onInit ios且版本大于12");
                    wx.setKeepScreenOn({
                        keepScreenOn: true
                      })
                    }
                }
              })
        }
    }
    //self.firstInit = true
    //
    UserManager.getInstance().initNewShopCube();
    //
    if(!self.resetAddStep) {
        self.resetAddStep = true;
        let topLevelId = 0;
        if(MysteryIslandManager.getInstance().isOpen()) {
            topLevelId = MysteryIslandManager.getInstance().getCurrentLevelId();
        }else{
            topLevelId = UserManager.getInstance().user.topLevelId;
        }
        UserManager.getInstance().initTopLevelFailCfg();
        UserManager.getInstance().setTopLevelFailTimes(topLevelId, UserManager.getInstance().getUserExtendRef().topLevelConsumeEnergyTryTimes);
    }
}

// let homeSceneWaterPosConfig = [
//     [cc.p(100, 100), 2],
//     [cc.p(300, 70)],
//     [cc.p(120, 240), 0.8],
//     [cc.p(650, 560)],
// ]

MiniHomeScene.prototype.releasMiniSceneTex = function () {
    let self = this
    MiniSceneAnim.unloadAnim(self)
    self.homeSceneAnimInited = false
}

MiniHomeScene.prototype.buildMiniSceneAnim = function () {
    let self = this
    if (self.homeSceneAnimInited) {
        return
    }
    self.homeSceneAnimInited = true
    setTimeout(() => {
        if (!__use_small_res) {
            MiniSceneAnim.playHomeSceneWaterAnim(self)
        }
        MiniSceneAnim.playBirdAnim(self)
        MiniSceneAnim.playMiniSceneFishAnim(self, true)
    }, 1000);
    // let waterNode = cc.Node.create()
    // self.waterNode = waterNode
    // self.addChild(waterNode, -9)
    // let scale = cc.winSize.height / 1280
    // for (let index = 0; index < homeSceneWaterPosConfig.length; index++) {
    //     let pos = homeSceneWaterPosConfig[index][0]
    //     pos.y *= scale

    //     let sprite = cc.Sprite.createWithSpriteFrameName("homeScene/home_scene_water.png")
    //     waterNode.addChild(sprite)
    //     sprite.setPosition(pos)
    //     let waterScale = homeSceneWaterPosConfig[index][1]
    //     if (waterScale) {
    //         sprite.setScale(waterScale)
    //     }
    // }
}
MiniHomeScene.prototype.onEnter = function () {
    let self = this
    // DnSdkTool.getInstance().onCreateRole()
    dc4UserLoad(140);
    // 重新进入场景以后，清除上一次未播放的动画
    self.stashPassStarAnim = null;

    BaseHomeScene.prototype.onEnter.call(self);
    cc.log("MiniHomeScene onEnter");
    if (MysteryIslandManager.getInstance().isOpen()){
        self.buildMysteryStartBtn();
        self.buildMysteryIsland()
    }else{
        self.buildIsland();
    }

    self.buildStarDrawBtn();
    
    self.updateTargets()



    // 过关后回到主界面，先屏蔽点击onEnterAfter后还原
    self.blockLayer = UIButton.create(cc.Node.create(), true)
    self.blockLayer.setContentSize(cc.Director.getInstance().getVisibleSize())
    self.addChild(self.blockLayer, 100000)

    console.log("[subscribe] HomeScene lastShowSubscribeWhatsNewTs", 
        UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs, 
        Localhost.time() - UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs)
    if (window.mini && mini.supportSubscribeSystemMessage() &&
        (Localhost.time() - UserManager.getInstance().userExtend.lastShowSubscribeWhatsNewTs > 7*24*3600*1000)){
        GameProxy.getInstance().checkNeedRequestSubscribeSystemMessage("SYS_MSG_TYPE_WHATS_NEW",
            (needRequest)=>{
                UserManager.getInstance().needRequestSubscribeSystemMessage = needRequest
                console.log("[subscribe] HomeScene needRequestSubscribeSystemMessage", UserManager.getInstance().needRequestSubscribeSystemMessage)
            })
    }
    
    console.log("[Preload] HomeScene onEnter 2", (new Date()).getTime())
    self.blockLayer.on(UIButtonEvent.Click, ()=>{
        cc.log("MiniHomeScene  self.blockLayer 没有被删除========== ")
    })
}
MiniHomeScene.prototype.onEnterAfter = function () {
    let self = this
    if (self.blockLayer){
        self.blockLayer.removeFromParent();
        self.blockLayer = null;
    }
    if (window.mini){
        SnsProxy.getInstance().setInIslandScene(false)
        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(true, true)
    }
    try {
        self.updateStartBtn()
        self.updateFriendPvp()
        self.buildMiniSceneAnim()

    }
    catch (e) {
        console.warn(e);
    }
    if (window.mini && mini.getPlatform() == MiniPlatform.baidu){
        // 百度防沉迷
        var sns = SnsProxy.getInstance();
        var lastState = sns.getAnitiAddictionState();
        if (lastState){
            sns.antiAddictionCb({state:lastState});
        }
    }
    //self.firstInit = false
    BaseHomeScene.prototype.onEnterAfter.call(self);
    //每次进入home场景后 收集一次玩家ai礼包实时特征值
    AIPkgManager.getInstance().collectUserAiInfo();
    //
    if(!self.firstEnergydc) {
        self.firstEnergydc = true;
        let num = UserEnergy.getInstance().getAvaliableEnergy()[0];
        DCAssist.userTrack("energy_recharge","energy_status", {
            session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
            num,
        })
    }

}
MiniHomeScene.prototype.updateStarChest = function () {
    let self = this
    let starChestType = UserManager.getInstance().getStarChestInfo().type
    if (self.chestIcon){
        let iconUp = self.chestIcon.getChildByName("box_uo")
        let iconDown = self.chestIcon.getChildByName("box_down")
        let iconStone = self.chestIcon.getChildByName("box_stone")
        if (starChestType === IslandType.advance) {
            iconUp.setSpriteFrame("open_star_chest/box_uo1_advance.png")
            iconDown.setSpriteFrame("open_star_chest/box_down_advance.png")
            iconStone.setSpriteFrame("open_star_chest/stone_advance.png")
        }else {
            iconUp.setSpriteFrame("open_star_chest/box_uo1.png")
            iconDown.setSpriteFrame("open_star_chest/box_down.png")
            iconStone.setSpriteFrame("open_star_chest/stone.png")
        }
        if (UserManager.getInstance().canOpenChest()) {
            self.updateChestCanOpen()
        }else {
            self.updateChestToNormal()
        }
        //self.updateTargets()
    }
}

// 进入游戏第一次刷新宝船
MiniHomeScene.prototype.updateGoldTurn = function (complete) {
    console.log("@@@@updateGoldTurn@@@@")
    let self = this;
    let callback = function(){
        let logic = GoldTurnLogic.getInstance();
        let info = logic.info;
        if (info && (info.status == 2 || info.status == 3 || info.status == 4)){
            logic.clearLevelTimes();
        }
    }
    var onResSuccess = function(){
        GoldTurnLogic.getInstance().updateIcon(self.btnLayer, [callback]);
        if (complete){
            complete();
        }
    }
    var onResFail = function(){
        if (complete){
            complete();
        }
    }
    const GoldTurnIconRes = ["packed/GoldTurnIconRes.pack"];
    preloadWithLoading(GoldTurnIconRes, onResSuccess, onResFail, onResFail);
    
}

MiniHomeScene.prototype.updateFriendPvp = function () {
    var friendPvpLogic = require("activity/PvpActivity/FriendPvpActivityLogic");
    friendPvpLogic.getInstance().updateIconNum();
}

let startBtnPosY = cc.winSize.height / 2
let islandNodePosY = cc.winSize.height / 2 + 80 * cc.winSize.height / 1280
let islandNodeHeight = 602
MiniHomeScene.prototype.buildStartBtn = function () {
    let self = this
    // self.buildMysteryStartBtn()
    self.startBtn = cc.CSLoader.createNode("cocos/island_btn_anim_anim.csb")
    self.startBtnAnim = cc.CSLoader.createTimeline("cocos/island_btn_anim_anim.csb")
    // self.startBtn.getChildByName("kuangkuang2").setVisible(false)
    self.startBtn.runAction(self.startBtnAnim)
    self.startBtnAnim.gotoFrameAndPlay(0, 0, false)
    self.startBtn.setAnchorPoint(0, 0)

    self.startBtn.setScale(Math.min(display.width / GamePlayConfig_Design_Width, display.height / GamePlayConfig_Design_Height))
    // self.startBtn.getChildByName("kuangkuang").setScale(1)
    // self.startBtn.getChildByName("kuangkuang2").setScale(1)
    // quickBuildUIBUtton(self.startBtn.getChildByName("button"), () => {
    //     self.onClickStartBtn()
    // })
    quickBuildUIBUtton(self.startBtn, () => {
        self.onClickStartBtn()
    })

    ButtonPushBounceIdleBubbleAnim.create(self.startBtn)
    let oldScoreParent = self.startBtn.getChildByName("level_1")
    let newScoreParent = self.startBtn.getChildByName("level_2")
    let level = UserManager.getInstance().user.topLevelId
    self.oldScore = oldScoreParent.getChildByName("label")
    self.newScore = newScoreParent.getChildByName("label")
    self.oldScore.setString(level)
    self.newScore.setString(level)
    newScoreParent.setPosition(oldScoreParent.getPosition())
    // tag 为 -100 的子节点会直接作为节点的 bounds 返回，以解决startBtn 点击范围不准的情况
    self.startBtn.getChildByName("button").setTag(-100)

    let strParent = self.startBtn.getChildByName("txt")
    self.startBtnLeftStr = strParent.getChildByName("label")
    self.startBtnLeftStr.setFntFile("font/zzgftongxin_70_miniscene_greenstroke.fnt")
    self.startBtnRightStr = strParent.getChildByName("lable2")
    self.startBtnRightStr.setFntFile("font/zzgftongxin_70_miniscene_greenstroke.fnt")

    self.startBtnLeftStr.setScale(5.5/7)
    self.startBtnRightStr.setScale(5.5/7)
    self.oldScore.setAnchorPoint(0.5, 0.5)
    self.newScore.setAnchorPoint(0.5, 0.5)
    self.oldScore.setPosition(0, 2)
    self.newScore.setPosition(0, 2)
    self.addChild(self.startBtn, MiniHomeSceneLayerDef.kStartBtn)

    let bottomHeight = 130
    let posy = Math.max(200, (startBtnPosY - islandNodeHeight / 2 - bottomHeight) / 2 + bottomHeight + 25)
    let size = self.startBtn.getChildByName("button").getContentSize()
    // if (!__use_small_res) {
    //     size.width = size.width / 0.625
    //     size.height = size.height / 0.9
    // }
    self.startBtn.setContentSize(size)
    self.startBtn.setPosition(cc.winSize.width / 2, posy)
    self.updateStartBtn()
}
MiniHomeScene.prototype.onClickMystertyStartBtn = function () {
    let self = this
    self.checkReportLastRunActionName()
    if (self.isBusy || self.needReplay) {
        console.log("`selectLevel failed - onClickMystertyStartBtn", self.isBusy, self.needReplay);
        window.logCenter && logCenter.error(new Error(`onClickMystertyStartBtn failed. isBusy=${self.isBusy},needReplay=${self.needReplay}`), 'selectLevelError')
        return
    }
    if (self.mysteryHandNode)self.mysteryHandNode.setVisible(false)
    if (self.mysteryTipTextNode)self.mysteryTipTextNode.setVisible(false)

    self.selectLevel(MysteryIslandManager.getInstance().getCurrentLevelId())
// self.playMysteryNormalStartBtnAnim()

}

/** 
 * 由于神秘岛先点击打开关前面板会调用GameResLoad.getInstance().checkPreload()。GameResLoad.taskList会有对应GameResLoadTask
 * 此时选择闪退续打。CreateGameSceneLogic.loadLevelConfig不会进入LevelLoadingScene
 * CreateGameSceneLogic.createReplayGamePlayScene无法创建ReplayGameScene。
 * BaseRedirector.redirect目前没有promise
 */
MiniHomeScene.prototype.setNeedReplay = function(isNeed) {
    let self = this
    self.needReplay = isNeed;
    if(isNeed) {
        //防止ResumeReplayAction没有run
        setTimeout(() => {
            self.needReplay = false;
        }, 3000);
    }
}
// 构建神秘岛开始按钮
MiniHomeScene.prototype.buildMysteryStartBtn = function () {
    let self = this
    if (self.startBtn)self.startBtn.setVisible(false)
    if (self.startMysteryBtn) return
    DCAssist.dc4User101("mystery_island_show", "icon_show", {
        "session":`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
        "high_stage": UserManager.getInstance().getMaxLevelServer()
    })


    self.startMysteryBtn = cc.CSLoader.createNode("cocos/island_mystery_btn_anim_xxd_btn.csb")
    self.addChild(self.startMysteryBtn, MiniHomeSceneLayerDef.kStartBtn)
    self.startMysteryBtn.setScale(Math.min(display.width / GamePlayConfig_Design_Width, display.height / GamePlayConfig_Design_Height))
    
    self.startMysteryBtnAnim = cc.CSLoader.createTimeline("cocos/island_mystery_btn_anim_xxd_btn.csb")
    self.startMysteryBtn.runAction(self.startMysteryBtnAnim)
    self.startMysteryBtnAnim.gotoFrameAndPlay(0, 0,false)


    let bottomHeight = 130
    let posy = Math.max(200, (startBtnPosY - islandNodeHeight / 2 - bottomHeight) / 2 + bottomHeight + 25)
    self.startMysteryBtn.setPosition(cc.winSize.width / 2, posy+0)
    let size = self.startMysteryBtn.getChildByName("button").getContentSize()
    self.startMysteryBtn.setContentSize(size)
    quickBuildUIBUtton(self.startMysteryBtn, () => {
        self.onClickMystertyStartBtn()
    })
    ButtonPushBounceIdleBubbleAnim.create(self.startMysteryBtn)



    

    // let lable2 = self.startMysteryBtn.getChildByName("txt").getChildByName("lable2")
    // self.startMysteryBtn.getChildByName("txt").getChildByName("label").setString("关")
    // lable2.setColor(cc.c3b(255,0,0))
    self.updateMysteryStartBtn()

}
MiniHomeScene.prototype.updateStartBtnOtherAnim = function () {

}
MiniHomeScene.prototype.updateStartBtnLevelCollect = function (isShowAnim) {
    let self = this
    let btn = self.startBtn
    let isMysteryIslandLevel = false
    if (MysteryIslandManager.getInstance().isOpen()){
        btn = self.startMysteryBtn
        isMysteryIslandLevel = true
    }
    let clean =  ()=>{
        if ( self._schedulerId_levelCollect){
            cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_levelCollect);
            self._schedulerId_levelCollect = null;
        }
        let cleanFunc = (key)=>{
            if (btn[key] ){
                btn[key].removeFromParent(true)
                btn[key] = null
            }
        }
        cleanFunc("startBtnLight")
        cleanFunc("timeLabel")
        cleanFunc("doubleCard")
        cleanFunc("zhong")
        cleanFunc("timeTag")

        
    }
    // let endTime = Localhost.time() + 30*2000
    let endTime = LevelCollectManager.getInstance().getDoubleCardBuffEnd()
    self.remain_time_levelCollect = endTime - Localhost.time()



    if (endTime > Localhost.time() && LevelCollectManager.getInstance().isOpen()){
        let updateLight = ()=>{
            if (!btn.startBtnLight){
                clean()
                let lightFile = "cocos/island_mystery_btn_anim_start_btn_light.csb"
                if (isMysteryIslandLevel){
                    lightFile = "cocos/island_mystery_btn_anim_start_btn_light_pink.csb"
                }
                
                let startBtnLight = cc.CSLoader.createNode(lightFile)
                let startBtnLightAnim = cc.CSLoader.createTimeline(lightFile)
                startBtnLight.runAction(startBtnLightAnim)
                startBtnLight.setPosition(3,3)
                startBtnLightAnim.gotoFrameAndPlay(0,true)
                btn.addChild(startBtnLight)
                // SpriteUtil.findBlendChilds_AddSrcalphaOne(startBtnLight, true);
                btn.startBtnLight = startBtnLight

              
                
                // let timeNode cc.Node.create()
                // let timeLabel = cc.LabelTTF.create("00:00:00", FONT_DEF.microsoftYahei_30_noStroke);
                // btn.addChild(timeLabel)
                // timeLabel.setPosition(35,-115)
                // btn.timeLabel = timeLabel
                // let zhong = cc.Sprite.createWithSpriteFrameName("island_mystery_btn_anim/zhong.png")
                // btn.addChild(zhong)
                // zhong.scale = 1.1
                // zhong.setPosition(-70,-110)
                // btn.zhong = zhong
    
                let timeTag = cc.CSLoader.createNode("cocos/StarLightWish_time_tag.csb")
    
                btn.addChild(timeTag)
                btn.timeTag = timeTag
                timeTag.y = -100
                btn.timeLabel = timeTag.getChildByName("num")
                // btn.timeLabel.setString("00:00:00")
                btn.timeLabel.setString(parseTimeToHMS(self.remain_time_levelCollect))
                
            }
        }
        if (isShowAnim){
            let startBtnShow = cc.CSLoader.createNode("cocos/island_mystery_btn_anim_start_btn_show.csb")
            let startBtnShowAnim = cc.CSLoader.createTimeline("cocos/island_mystery_btn_anim_start_btn_show.csb")
            if (isMysteryIslandLevel){
                startBtnShow.getChildByName("btnguang").setSpriteFrame("island_mystery_btn_anim/pink_btnguang.png" )
            }
    
            startBtnShow.runAction(startBtnShowAnim)
            startBtnShow.setPosition(5,3)
            startBtnShowAnim.gotoFrameAndPlay(0,false)
            btn.addChild(startBtnShow)
            // SpriteUtil.findBlendChilds_AddSrcalphaOne(startBtnShow, true);
    
            startBtnShowAnim.setLastFrameCallFunc(() => {
                if (startBtnShow)startBtnShow.removeFromParent(true)
            });
        }
        updateLight()
    

    }else{
        clean()
        return
    }

    if (self.remain_time_levelCollect > 0 && !self._schedulerId_levelCollect){
        self._schedulerId_levelCollect = cc.director.getScheduler().scheduleScriptFunc(function () { 
            // self.remain_time_levelCollect -= 1000
            self.remain_time_levelCollect = endTime - Localhost.time()
            if (!btn.timeLabel) return
            if (self.remain_time_levelCollect > 0){
                btn.timeLabel.setString(parseTimeToHMS(self.remain_time_levelCollect))
            }else{
                btn.timeLabel.setString("活动结束")  
                clean()
            }
        }, 1, false);
    }
}
MiniHomeScene.prototype.updateStartBtnSeasideStar = function () {
    let self = this
    let btn = self.startBtn
    if (MysteryIslandManager.getInstance().isOpen()){
        btn = self.startMysteryBtn
    }
    let clean =  ()=>{
        if ( self._schedulerId_seasideStar){
            cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_seasideStar);
            self._schedulerId_seasideStar = null;
        }
        let cleanFunc = (key)=>{
            if (btn[key] ){
                btn[key].removeFromParent(true)
                btn[key] = null
            }
        }
        cleanFunc("startBtnLight")
        cleanFunc("timeLabel")
        cleanFunc("doubleCard")
        cleanFunc("zhong")
    }
    if (!SeasideStarManager.getInstance().isOpen()){
        clean()
        return
    }
    let endTime = SeasideStarManager.getInstance().getDoubleCardBuffEnd()

    if (endTime > Localhost.time()){
        if (!btn.startBtnLight){
            clean()
            let startBtnLight = cc.CSLoader.createNode("cocos/island_mystery_btn_anim_start_btn_light.csb")
            let startBtnLightAnim = cc.CSLoader.createTimeline("cocos/island_mystery_btn_anim_start_btn_light.csb")
            startBtnLight.runAction(startBtnLightAnim)
            startBtnLight.setPosition(10,3)
            startBtnLightAnim.gotoFrameAndPlay(0,true)
            btn.addChild(startBtnLight)
            SpriteUtil.findBlendChilds_AddSrcalphaOne(startBtnLight, true);
            btn.startBtnLight = startBtnLight
            
            // let timeNode cc.Node.create()
            let timeLabel = cc.LabelTTF.create("00:00:00", FONT_DEF.microsoftYahei_30_noStroke);
            btn.addChild(timeLabel)
            timeLabel.setPosition(35,-115)
            btn.timeLabel = timeLabel
            let zhong = cc.Sprite.createWithSpriteFrameName("island_mystery_btn_anim/zhong.png")
            btn.addChild(zhong)
            zhong.scale = 1.1
            zhong.setPosition(-70,-110)
            btn.zhong = zhong


            let doubleCard = SeasideStarManager.getInstance().createDoubleCardNode() 
            btn.addChild(doubleCard)
            doubleCard.setPosition(175,50)
            btn.doubleCard = doubleCard
        }
    }else{
        clean()
        return
    }
    self.remain_time_seasideStar = endTime - Localhost.time()

    if (self.remain_time_seasideStar > 0 && !self._schedulerId_seasideStar){
        self._schedulerId_seasideStar = cc.director.getScheduler().scheduleScriptFunc(function () { 
            self.remain_time_seasideStar -= 1000
            if (self.remain_time_seasideStar > 0){
                btn.timeLabel.setString(parseTimeToHMS(self.remain_time_seasideStar))
            }else{
                btn.timeLabel.setString("活动结束")  
                clean()
            }
        }, 1, false);
    }

}


MiniHomeScene.prototype.updateMysteryStartBtn = function () {
    let self = this
    // 
    if(   self.mysteryHandNode ){
        self.mysteryHandNode.removeFromParent()
        self.mysteryTipTextNode.removeFromParent()
        self.mysteryHandNode = null
        self.mysteryTipTextNode = null
    }
    let isGuide = MysteryIslandManager.getInstance().isGuide()
    if (isGuide){
        self.mysteryHandNode = cc.CSLoader.createNode("cocos/island_mystery_btn_anim_hand.csb")
        self.startMysteryBtn.addChild(self.mysteryHandNode)
        self.mysteryHandNode.setPosition(150,-100)
        let handAnim = cc.CSLoader.createTimeline("cocos/island_mystery_btn_anim_hand.csb")
        self.mysteryHandNode.runAction(handAnim)
        handAnim.gotoFrameAndPlay(0, true)

        self.mysteryTipTextNode = cc.CSLoader.createNode("cocos/island_mystery_btn_anim_text.csb")
        self.startMysteryBtn.addChild(self.mysteryTipTextNode)
        self.mysteryTipTextNode.setPosition(0,120)
        let textAnim = cc.CSLoader.createTimeline("cocos/island_mystery_btn_anim_text.csb")
        self.mysteryTipTextNode.runAction(textAnim)
        textAnim.gotoFrameAndPlay(0, true)
        MysteryIslandManager.getInstance().setGuide()
    }
    self.startMysteryBtn.getChildByName("xxd").setVisible(isGuide)
    self.startMysteryBtn.getChildByName("xxdz").setVisible(!isGuide)
    self.startMysteryBtn.getChildByName("txt").setVisible(!isGuide)


    let xxd_level = self.startMysteryBtn.getChildByName("txt").getChildByName("xxd_level")
    xxd_level.setPosition(0,25)
    xxd_level.getVirtualRenderer().setAlignment(cc.TEXT_ALIGNMENT_CENTER)
    xxd_level.setAnchorPoint(0.5,1)

    xxd_level.setString(MysteryIslandManager.getInstance().getCurentLevelNo())
    xxd_level.scale = 1.2
    let leftLabel = self.startMysteryBtn.getChildByName("txt").getChildByName("label")
    let rightLabel = self.startMysteryBtn.getChildByName("txt").getChildByName("lable2")
    // leftLabel.x = xxd_level.x - (xxd_level.width*xxd_level.scale + leftLabel.width/2*leftLabel.scale)

    rightLabel.x = xxd_level.x + (xxd_level.width*xxd_level.scale/2 + rightLabel.width/2*rightLabel.scale + 10)
    leftLabel.x = xxd_level.x - (xxd_level.width*xxd_level.scale/2 + leftLabel.width/2*leftLabel.scale + 10)
    // leftLabel.x = 0
    // self.updateStartBtnOtherAnim(self.startMysteryBtn)
}
MiniHomeScene.prototype.buildTargets =  function() {
    let self = this
    let targetNode = NewIntroNode.create();
    targetNode.setPosition(cc.winSize.width / 2, self.startBtn.y + self.startBtn._contentSize.width / 4 + 18);
    self.addChild(targetNode, MiniHomeSceneLayerDef.kTargetsNode);
    self.targetNode = targetNode;
    self.targetNode.setScale(Math.min(display.width / GamePlayConfig_Design_Width, display.height / GamePlayConfig_Design_Height))
}

MiniHomeScene.prototype.buildBubugTools = function () {
    let self = this
    if (!__DEBUG) {
        return
    }
    self.testUpdate = cc.Sprite.createWithSpriteFrameName("homeScene/signIn_sp_new.png")
    self.testUpdate.setAnchorPoint(0, 0)
    self.addChild(self.testUpdate)
    self.testUpdate.setPosition(10, 10)
    quickBuildUIBUtton(self.testUpdate, () => {
        UpdateManager.getInstance().testUpdate()
    })
}
MiniHomeScene.prototype.updateTargets = function (force = false) {
    this.targetNode.update();
}
MiniHomeScene.prototype.checkReportLastRunActionName = function () {
    try {
        if (this.isReportLastRunActionNameFlag){
            return
        }
        this.isReportLastRunActionNameFlag = true
        let name = HomeScenePopoutQueue.getInstance().getLastRunActionName()
        if(UserManager.getInstance().getSettingByKey("enableReportLastAction", 0)) {
            cc.log("checkReportLastRunActionName",name)
            window.logCenter && logCenter.error(new Error(`checkReportLastRunActionName name=${name}`), 'HomeScenePopout')
        }
    } catch (error) {   
    }
}
MiniHomeScene.prototype.onClickStartBtn = function () {
    let self = this
    self.checkReportLastRunActionName()
    if (self.isBusy) {
        console.log("`selectLevel failed - onClickStartBtn")
        window.logCenter && logCenter.error(new Error(`onClickStartBtn failed. isBusy=${self.isBusy}`), 'selectLevelError')
        return
    }

    if (UserManager.getInstance().reachTopLevel()) {
        require.ensure([], () => {
            let logic = require("clover/scene/component/homescene/IslandBook/IslandBookLogic")
            logic.openIslandBook(null, ()=>{}, ()=>{})
        }, null, 'act')

    } else if (UserManager.getInstance().topIslandNeedUnlock()) {
        let doFunction = ()=>{
            require.ensure([], () => {
                require("clover/panel/unlock/UnlockIslandLogic").getInstance().start();
            }, null, 'act')
        }
        doFunction()
        // AuthorizeMgr.checkAuthorizeByScope("FriendInteraction",doFunction,doFunction,true,true)
    }else {
        self.selectLevel(UserManager.getInstance().user.topLevelId)
    }
}

MiniHomeScene.prototype.startMaxlevel = function () {
    let self = this
    if (self.isBusy) {
        console.log("`selectLevel failed - startMaxlevel")
        return
    }

    if (UserManager.getInstance().reachTopLevel()) {
        self.selectLevel(UserManager.getInstance().user.topLevelId - 1)
    } else if (UserManager.getInstance().topIslandNeedUnlock()) {
        self.selectLevel(UserManager.getInstance().user.topLevelId - 1)    
    }else {
        self.selectLevel(UserManager.getInstance().user.topLevelId)
    }
}

MiniHomeScene.prototype.updateHeadFrame = function () {
    // let self = this
    // let headframeNode = self.userInfoBtn.getChildByName("headframe")
    // headframeNode && headframeNode.removeFromParent(true)
    // self.buildUserHeadFrame()
}
MiniHomeScene.prototype.scrollToLevel = function (toLevel, callback) {
    let self = this
    setTimeout(() => {
        callback && callback()
    }, 0);
}
MiniHomeScene.prototype.showPassStarAnim = function (levelId, score, oldScore, onEnd) {
    let self = this
    self.stashPassStarAnim = null;
    if (self.newChestConfig)
        HomeSceneAnimation.showPassStarAnimStarDraw(score, oldScore, onEnd, false, self.starDraw);
    else {     
        // onEnd && onEnd();
        // 等待starDrawConfig创建完毕
        self.stashPassStarAnim = {
            levelId, score, oldScore, onEnd
        }
    }

}
MiniHomeScene.prototype.playMysteryNormalStartBtnAnim = function (callback) {
    let self = this
    if (!self.startMysteryBtn){
        callback && callback()
        return
    }
    self.startMysteryBtn.stopAllActions()
    let xxd_level = self.startMysteryBtn.getChildByName("txt").getChildByName("xxd_level")
    xxd_level.setString(MysteryIslandManager.getInstance().getCurentLevelNo())
    self.updateMysteryStartBtn()
    callback && callback()
    return


    let startBtnKuang = cc.CSLoader.createNode("cocos/island_btn_anim_start_btn_kuangkuang.csb")
    let startBtnKuangAnim = cc.CSLoader.createTimeline("cocos/island_btn_anim_start_btn_kuangkuang.csb")
    if (__use_small_res) {
        // startBtnKuang.setPosition(40, 30)
    }
    // let kcolor = cc.c4b(255, 255, 255,255)
    // let bei1 = cc.Sprite.createWithSpriteFrameName("mystery_island_animal/bei1.png")

    startBtnKuang.getChildByName("kuangkuang").setSpriteFrame("island_mystery_btn_anim/kuangkuang_mystery.png" )
    startBtnKuang.getChildByName("kuangkuang2").setSpriteFrame("island_mystery_btn_anim/kuangkuang_mystery.png" )

    
    self.startMysteryBtn.addChild(startBtnKuang)

    startBtnKuang.runAction(startBtnKuangAnim)
    startBtnKuangAnim.gotoFrameAndPlay(0, false)

    self.startMysteryBtnAnim.gotoFrameAndPlay(0, 29,false)
    self.startMysteryBtn.runAction(self.startMysteryBtnAnim)
    self.startMysteryBtnAnim.setLastFrameCallFunc(() => {
        self.startMysteryBtnAnim.clearLastFrameCallFunc()
        let xxd_level = self.startMysteryBtn.getChildByName("txt").getChildByName("xxd_level")
        xxd_level.setString(MysteryIslandManager.getInstance().getCurentLevelNo())
        self.startMysteryBtnAnim.gotoFrameAndPlay(30,false)
        self.startMysteryBtnAnim.setLastFrameCallFunc(() => {
            self.startMysteryBtnAnim.clearLastFrameCallFunc()
            startBtnKuang.removeFromParent()
            self.updateMysteryStartBtn()
            callback && callback()
        })

    })

}
MiniHomeScene.prototype.playNormalStartBtnAnim = function (callback) {
    let self = this
    self.startBtn.stopAllActions()
    let level = UserManager.getInstance().user.topLevelId
    self.newScore.setString(level)
    self.oldScore.setString(self.newScore.getString())
    self.updateStartBtn()
    callback && callback()
    return;
    // self.startBtn.getChildByName("kuangkuang2").setVisible(true)
    // self.newScore.setVisible(true)
    
    if (!self.startBtnKuang) {
        self.startBtnKuang = cc.CSLoader.createNode("cocos/island_btn_anim_start_btn_kuangkuang.csb")
        self.startBtnKuangAnim = cc.CSLoader.createTimeline("cocos/island_btn_anim_start_btn_kuangkuang.csb")
        if (__use_small_res) {
            self.startBtnKuang.setPosition(40, 30)
        }
    }else {
        self.startBtnKuang.stopAllActions()
    }
    self.startBtn.addChild(self.startBtnKuang)

    if (!__use_small_res) {
        if (!self.particleNode) {
            self.particleNode = cc.CSLoader.createNode("cocos/island_btn_anim_start_btn_particle.csb")
            self.particleNode.setContentSize(200, 70)
            self.particleNodeAnim = cc.CSLoader.createTimeline("cocos/island_btn_anim_start_btn_particle.csb")
            self.startBtn.addChild(self.particleNode)
        }else {
            self.particleNode.stopAllActions()
            self.particleNodeAnim.pause()
        }
        // self.startBtn.addChild(self.particleNode)
    }

    // let level = UserManager.getInstance().user.topLevelId
    // self.newScore.setString(level)
    // self.startBtnKuang.runAction(self.startBtnKuangAnim)
    // self.startBtnKuangAnim.gotoFrameAndPlay(0, false)
    // if (self.particleNode) {
    //     self.particleNode.runAction(self.particleNodeAnim)
    //     self.particleNodeAnim.gotoFrameAndPlay(0, false)
    // }
    // self.startBtn.runAction(self.startBtnAnim)
    // self.startBtnAnim.gotoFrameAndPlay(0, false)
    // self.startBtnAnim.setLastFrameCallFunc(() => {
    //     self.startBtnAnim.clearLastFrameCallFunc()
    //     self.oldScore.setString(self.newScore.getString())
    //     // self.particleNode.removeFromParent()
    //     self.startBtnKuang.removeFromParent()
    //     self.updateStartBtn()

    //     callback && callback()

    // })

}

//达到岛屿满星的分享
MiniHomeScene.prototype.dealFullStarShare = function (callback)
{
    let self = this
    self.playNormalStartBtnAnim(callback)
    self.checkGoldTurnShipAnim();
    return;
    let IslandFullStarPanel = require("clover/scene/component/homescene/IslandBook/IslandFullStarPanel");
    IslandFullStarPanel.asyncCreate(function () {
            self.playNormalStartBtnAnim(callback)
            self.checkGoldTurnShipAnim();
    }, function () {
            self.playNormalStartBtnAnim(callback)
            self.checkGoldTurnShipAnim();
    }, function () {
            self.playNormalStartBtnAnim(callback)
            self.checkGoldTurnShipAnim();
    })
}

MiniHomeScene.prototype.playUpdateStartBtnAnim = function (callback, passOldLevel = false) {
    console.log("!!!!playUpdateStartBtnAnim!!!!")
    let self = this

    let IslandBookManager = require("clover/scene/component/homescene/IslandBook/IslandBookManager")
    let fullStarDone = false
    try 
    {
        fullStarDone = IslandBookManager.getInstance().fullStarDone()
    }
    catch(err)
    {

    }

    if (!UserManager.getInstance().canUnlockNewIsland()) {
        if (fullStarDone)
        {
            //过关导致满星
            this.dealFullStarShare(callback)
        }
        else
        {
            this.playNormalStartBtnAnim(callback)
        }
        self.checkGoldTurnShipAnim();
    } else {
        //  检查是否可以解锁新岛屿，如果可以解锁，则显示解锁界面并播放动画，否则打开解锁面板
        if (UserManager.getInstance().topIslandNeedUnlock()) {
            require.ensure([], () => {
            let logic = require("clover/panel/unlock/UnlockIslandLogic").getInstance();
            //如果先点击了按钮解锁，则不在自动解锁岛屿
            if (passOldLevel || logic.isBusy) {
                callback && callback();
                return;
            }
                var onSuccess = function(unlockType){
                    if (fullStarDone)
                    {
                        DCAssist.dc4User101("island_star", "unlock_show", {
                            "levelid": IslandBookManager.getInstance().playingislandId,
                            "current_stage": IslandBookManager.getInstance().playingLevelId})
                    }
    
                    let IslandUpgradeSharePanel = require("clover/panel/IslandUpgradeSharePanel");
                    IslandUpgradeSharePanel.asyncCreate(unlockType, function () {
                        self.playChageIslandAnim(() => {
                            self.playNormalStartBtnAnim(callback)
                            self.checkGoldTurnShipAnim();
                        })
                    }, function () {
                        self.playChageIslandAnim(() => {
                            self.playNormalStartBtnAnim(callback)
                            self.checkGoldTurnShipAnim();
                        })
                    }, function () {
                        self.playChageIslandAnim(() => {
                            self.playNormalStartBtnAnim(callback)
                            self.checkGoldTurnShipAnim();
                        })
                    }, function(){
                        self.playNormalStartBtnAnim(callback)
                        self.checkGoldTurnShipAnim();
                    })
                }
                
                var onFail = function(info){
                    //  解锁失败，展示解锁面板
                    callback && callback();
                    self.updateStartBtn();
                    let closeCb = function(){
                        // 解锁面板关闭后检查宝船
                        self.checkGoldTurnShipAnim();
                    }
                    logic.showPanel(info, closeCb);
                }
            
                logic.tryUnlockIsland(onSuccess, onFail);
            }, null, 'act')
        }
        else if (fullStarDone)
        {
            //过关导致满星
            this.dealFullStarShare(callback)
        }
        else {
            self.playChageIslandAnim(() => {
                self.playNormalStartBtnAnim(callback)
                self.checkGoldTurnShipAnim();
            })
        }
    }
}
MiniHomeScene.prototype.updateStartBtn = function () {
    let self = this
    if (UserManager.getInstance().reachTopLevel()) {
        if (!self.reachMaxTxt) {
            self.oldScore.setVisible(false)
            self.newScore.setVisible(false)
            self.startBtnLeftStr.setVisible(false)
            self.startBtnRightStr.setVisible(false)
            self.reachMaxTxt = cc.LabelBMFont.create("去刷星", "font/zzgftongxin_70_miniscene_greenstroke.fnt")
            self.startBtn.addChild(self.reachMaxTxt)
            self.reachMaxTxt.setScale(5.5/7)
        }
    } else if (UserManager.getInstance().topIslandNeedUnlock()) {
        if (!self.unlockIslandTxt) {
            let info = UserManager.getInstance().getIslandsInfo();
            let islandsConfig = UserManager.getInstance().getIslandConfigById(info.topId);
            self.oldScore.setString(islandsConfig.maxLevel);
            self.oldScore.setVisible(false);
            self.newScore.setVisible(false);
            self.startBtnLeftStr.setVisible(false);
            self.startBtnRightStr.setVisible(false);
            self.unlockIslandTxt = cc.LabelBMFont.create(getText("island_unlock_btn"), "font/zzgftongxin_70_miniscene_greenstroke.fnt")
            self.startBtn.addChild(self.unlockIslandTxt)
            self.unlockIslandTxt.setScale(5.5/7)
            //  解锁岛屿按钮打点曝光
            let islandsManager = IslandsManager.getInstance();
            DCAssist.dc4User101("island", "unlock_btn_show", {
                id: (info.topId+1),
                stars: islandsManager.getTargetIslandGetedStarCount(info.topId)
            });
        }
    }else {
        let level = UserManager.getInstance().user.topLevelId
        self.oldScore.setVisible(true)
        self.oldScore.setString(level)
        let delta = 0
        let oldfntWidth = self.oldScore._contentSize.width
        let newfntWidth = self.oldScore._contentSize.width
        let fntSzie = Math.max(oldfntWidth, newfntWidth)
        if (!self.lastWidth) {
            delta = (fntSzie - 80) / 2
        }else {
            delta = (fntSzie - self.lastWidth) / 2
        }
        self.lastWidth = fntSzie
        // self.startBtnLeftStr.runAction(cc.MoveBy.create(0.3, -delta, 0))
        // self.startBtnRightStr.runAction(cc.MoveBy.create(0.3, delta, 0))
        self.startBtnLeftStr.x -= delta
        self.startBtnRightStr.x += delta

        if (self.unlockIslandTxt) {
            self.oldScore.setVisible(true);
            self.newScore.setVisible(true);
            self.startBtnLeftStr.setVisible(true);
            self.startBtnRightStr.setVisible(true);
            self.unlockIslandTxt.removeFromParent(true);
        }
        if (self.reachMaxTxt) {
            self.oldScore.setVisible(true);
            self.newScore.setVisible(true);
            self.startBtnLeftStr.setVisible(true);
            self.startBtnRightStr.setVisible(true);
            self.reachMaxTxt.removeFromParent(true);
        }
    }
    // self.startBtn.levelNum.setString(level)
    // if (self.islandNode) {
    //     let bottomHeight = 130
    //     let posy = Math.max(200, (self.islandNode.y - self.islandNode.getContentSize().height / 2 - bottomHeight) / 2 + bottomHeight + 10)
    //     self.startBtn.y = posy
    // }
    // this.updateStartBtnOtherAnim(self.startBtn)
}


MiniHomeScene.prototype.buildStarDrawBtn = function(){
    var self = this;
    const Event = require("hecore/EventDispatcher").Event;
    var onInfoSuccess = function(evt){
        cc.log("onInfoSuccess", evt);
        CfgManager.load("new_chest")
        .then((data) => {
            self.newChestConfig = data.get("new_chest");
            cc.log("new_chest config", self.newChestConfig)
            CfgManager.release("new_chest");

            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
                {
                    id: WelfareCenterId.starDraw,
                }))
        });
        // return;
        var info = evt.data;
        UserManager.getInstance().updateUserInfoByKey("starDrawRaffled", info.haveDraw);
        UserManager.getInstance().updateUserInfoByKey("starDrawGuide", info.haveGuide);
        if (!self.starDraw){
            if(!UserManager.getInstance().isHideStarDrawIcon()) {
                self.starDraw = cc.Node.create();
                let clickLayer = cc.LayerColor.create(cc.color(0,0,0,0), 120, 120);
                clickLayer.ignoreAnchorPointForPosition(false);
                self.starDraw.addChild(clickLayer, -5);
                clickLayer.setTag(-100);
                self.starDraw.setContentSize(clickLayer.getContentSize());
                self.starDraw.setAnchorPoint(0, -0.5);
                self.btnLayer.addBtnToSelf(self.starDraw, ICON_TYPE.kLeft, "kRedBag")
                quickBuildUIBUtton(self.starDraw, () => {
                    self.onClickStarDrawBtn();
                })
                //
                DCAssist.userTrack("newchest", "icon_show",{session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`});
            }

            var onResSuccess = function(){
                CfgManager.load("new_chest")
                .then((data) => {
                    self.newChestConfig = data.get("new_chest");
                    cc.log("new_chest config", self.newChestConfig)
                    HomeSceneAnimation.refreshStarDrawBtn(info, false, self.starDraw, self.newChestConfig);
                    CfgManager.release("new_chest");

                    if (self.stashPassStarAnim) {
                        let stashData = self.stashPassStarAnim;
                        self.stashPassStarAnim = null;
                        HomeSceneAnimation.showPassStarAnimStarDraw(stashData.score, stashData.oldScore, stashData.onEnd, false, self.starDraw);
                    }
                });
            }
            var onResFail = function(){
            }
            preloadWithLoading(["packed/StarDrawIconRes.pack"], onResSuccess, onResFail, onResFail);
        }else{
            if (info.canDrawSmall || info.canDrawBig){
                Toast.make(getText("new_chest_tip_invite_success"));
            }
            HomeSceneAnimation.refreshStarDrawBtn(info, false, self.starDraw, self.newChestConfig);
        }
    }

    var onInfoFail = function(evt){
        self.isBusy = false;
        GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
            {
                id: WelfareCenterId.starDraw,
                type: "del"
            }))
    }

    var http = GetStarRewardPoolHttp.new();
    http.addEventListener(Events.kComplete, onInfoSuccess);
    http.addEventListener(Events.kError, onInfoFail);
    http.addEventListener(Events.kCancel, onInfoFail);
    http.load();
}

MiniHomeScene.prototype.starDrawCloseCb = function(){
    var self = this;

    var getStarDrawInfo = function(){
        var onInfoSuccess = function(evt){
            var info = evt.data;
            HomeSceneAnimation.refreshStarDrawBtn(info, false, self.starDraw, self.newChestConfig);
        }
        var onInfoFail = function(evt){
            cc.log(evt);
            self.isBusy = false;
        }
    
        var http = GetStarRewardPoolHttp.new();
        http.addEventListener(Events.kComplete, onInfoSuccess);
        http.addEventListener(Events.kError, onInfoFail);
        http.addEventListener(Events.kCancel, onInfoFail);
        http.load();
    }
    
    // 星星抽奖退出用老的宝箱接口刷新星星数
    var onInfoSuccess = function(evt){
        UserManager.getInstance().updateStarChestInfo(evt.data && evt.data.starChestInfo);
        getStarDrawInfo();
    }
    var onInfoFail = function(evt){
        cc.log(evt);
        self.isBusy = false;
    }
    
    var http = GetStarChestInfoHttp.new();
    http.addEventListener(Events.kComplete, onInfoSuccess);
    http.addEventListener(Events.kError, onInfoFail);
    http.addEventListener(Events.kCancel, onInfoFail);
    http.load();

}

MiniHomeScene.prototype.onClickStarDrawBtn = function () {
    var self = this;
    if (self.isBusy){
        return;
    }
    self.isBusy = true;
    DCAssist.dc4ClickIcon("newchest", "click_icon");
    self.showStarDraw();
}

MiniHomeScene.prototype.showStarDraw = function(){
    var self = this;
    var info = null;

    var onInfoSuccess = function(evt){
        info = evt.data;
        var onResSuccess = function(){
            require.ensure([], () => {
                let StarDrawPanel = require("clover/scene/StarDrawPanel")
                self.starDrawPanel = StarDrawPanel.create(info, self.newChestConfig, handler(self, self.starDrawCloseCb));
                self.isBusy = false;
            }, null, 'act')
 
        }
        var onResFail = function(){
            cc.log("load star chest fail");
            self.isBusy = false;
        }
        preloadWithLoading(["packed/StarDrawRes.pack"], onResSuccess, onResFail, onResFail);
    }
    var onInfoFail = function(evt){
        self.isBusy = false;
        cc.error(evt);
    }
    var http = GetStarRewardPoolHttp.new();
    http.addEventListener(Events.kComplete, onInfoSuccess);
    http.addEventListener(Events.kError, onInfoFail);
    http.addEventListener(Events.kCancel, onInfoFail);
    http.load();
}

MiniHomeScene.prototype.buildIsland = function () {
    let self = this

    if (self.islandNode){
        self.islandNode.removeFromParent(true);
        self.islandNode = null;
    }
    
    let topIslandId = 0;
    if (UserManager.getInstance().reachTopLevel()) {
        topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
    } else {
        topIslandId = UserManager.getInstance().getIslandsInfo().topId;
        if (topIslandId === 0) {
            topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
        }
    }
    let topIslandConfig = UserManager.getInstance().getIslandConfigById(topIslandId);
    let islandRes = IslandsManager.getInstance().getIslandRes(topIslandConfig);
    preloadWithLoading(islandRes.resList, () => {
        self.islandNode = cc.SpriteWithHue.create(islandRes.island)
        self.islandNode.setRangeRate(1)
        self.addChild(self.islandNode, MiniHomeSceneLayerDef.kIslands)
        self.islandNode.setPosition(cc.winSize.width / 2, islandNodePosY)
        // self.islandNode.setScale(720 / IslandItemNode2.ContentSize.width)
        if (islandRes.hasOwnProperty("animClass")) {
            self.extraAnimNode = islandRes["animClass"].create()
            self.islandNode.addChild(self.extraAnimNode)
            self.extraAnimNode.scale = IslandItemNode2.AniScale;
            self.extraAnimNode.setPosition(IslandItemNode2.AniPosition.x, IslandItemNode2.AniPosition.y);
        }
        quickBuildUIBUtton(self.islandNode, handler(self, self.showIslandWord))

        // 缩小点击区域范围
        const w = 0.6, h = 0.8
        self.islandNode.setTouchArea(cc.rect(self.islandNode.getPosition().x - IslandItemNode2.ContentSize.width * w / 2,
        self.islandNode.getPosition().y - IslandItemNode2.ContentSize.height * h / 2, 
        IslandItemNode2.ContentSize.width * w,
        IslandItemNode2.ContentSize.height * h));
        // self.updateStartBtn()
    }, null, null, false)
}
// 构建神秘岛
MiniHomeScene.prototype.buildMysteryIsland = function () {
    let self = this
    if (self.islandNode){
        self.islandNode.removeFromParent(true);
        self.islandNode = null;
    }
    if (self.islandMysteryNode){
        self.islandMysteryNode.removeFromParent(true);
        self.islandMysteryNode = null;
    }
    
    preloadWithLoading(["packed/MysteryIslandHome.pack"], () => {
        self.islandMysteryNode = cc.CSLoader.createNode("cocos/mystery_island_animal_background.csb");
        self.addChild(self.islandMysteryNode, MiniHomeSceneLayerDef.kIslands)

        // quickBuildUIBUtton(self.islandNode, handler(self, self.showIslandWord))
        self.islandMysteryNode.setPosition(cc.winSize.width / 2, islandNodePosY)
        self.islandMysteryNode.setScale(720 / IslandItemNode2.ContentSize.width)
        // self.islandMysteryNode.setAnchorPoint(0.5,0.5)
        // self.islandMysteryNode.setContentSize(500,500)
        quickBuildUIBUtton(self.islandMysteryNode.getChildByName("dao"), handler(self, self.onClickMystertyStartBtn))
        self.islandMysteryNode.getChildByName("bei1").setVisible(false)

        self.islandMysteryNode.setScale(Math.min(display.width / GamePlayConfig_Design_Width, display.height / GamePlayConfig_Design_Height))

        let bei1 = cc.Sprite.createWithSpriteFrameName("mystery_island_animal/bei1.png")

        bei1.setAnchorPoint(0.5,0.5)
        bei1.setPosition(0, 0)
        self.islandMysteryNode.addChild(bei1)
        bei1.setLocalZOrder(-1)

        bei1.runAction(cc.repeatForever(
            cc.sequence(
                cc.rotateTo(4,180),
                cc.rotateTo(4,360)
            )
        ));
        // bei1.setAnchorPoint(1,0.5)
        // // self.islandMysteryNode.setContentSize(300,300)
        self.islandMysteryNodeAnim = cc.CSLoader.createTimeline("cocos/mystery_island_animal_background.csb")
        // self.startBtn.getChildByName("kuangkuang2").setVisible(false)
        self.islandMysteryNode.runAction(self.islandMysteryNodeAnim)
        self.islandMysteryNodeAnim.gotoFrameAndPlay(0,true)
    })

}
MiniHomeScene.prototype.showIslandWord = function () {
    cc.log("-========= TODO ===========-")
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    require.ensure([], () => {
        let logic = require("clover/scene/component/homescene/IslandBook/IslandBookLogic")
        logic.openIslandBook(
            ()=> self.isBusy = false,
            ()=> self.isBusy = false,
            ()=> {
                self.isBusy = false
            },{
                id: null,
                is_show_top_island: true,
            }
        );  
    }, null, 'act')

    // self.isBusy = true
    // require("clover/scene/component/IslandsSystem/IslandsLogic").getInstance().showPanel(() => {
    //     self.isBusy = false
    // })
    DCAssist.dc4ClickIcon("island", "click_icon")
}
MiniHomeScene.prototype.updateChestToNormal = function () {
    let self = this

    self.stopStarChestCanRewardAnim()    
    // self.starChestTitle.setVisible(true)
    // starChestProgress.setVisible(true)
    // self.starChest.getChildByName("progress_bg").setVisible(true)
    // self.starChestStar.setVisible(true)
    // self.starChest.getChildByName("num").setVisible(true)
    // self.starChest.getChildByName("openText").setVisible(false)
    // self.starChestProcessbar.setVisible(true)
    self.starChestProcessbar.setOpacity(255)
    self.chestIcon.y = 0
    self.starChestCloud.y = -30
    // self.starChestTitle.setVisible(true)
    // self.openText.setVisible(false)

    let totalStar = UserManager.getInstance().getStarChestInfo().starCount
    self.updateStarChestProgress(totalStar)
    
    if (self.canOpenChestBubble != undefined && self.canOpenChestBubble != 0){
        self.canOpenChestBubble.setVisible(false);
    }
}
MiniHomeScene.prototype.updateChestCanOpen = function () {
    let self = this
    // self.starChest.getChildByName("title").setVisible(false)
    // self.starChest.getChildByName("progress").setVisible(false)
    // self.starChest.getChildByName("progress_bg").setVisible(false)
    // self.starChestStar.setVisible(false)
    // self.starChest.getChildByName("num").setVisible(false)
    // self.starChest.getChildByName("openText").setVisible(true)
    // self.starChestProcessbar.setVisible(false)
    // self.starChestTitle.setVisible(false)
    // self.openText.setScale(1)
    // self.openText.setVisible(true)
    self.chestIcon.y = -7
    self.starChestCloud.y = -37
    self.starChestProcessbar.setOpacity(0)
    self.playStarChestCanRewardAnim()

    // let action1 = cc.Sequence.create(cc.ScaleTo.create(0.2, 0, 0))
    // self.starChest.getChildByName("title").runAction(action1)
    // self.starChest.getChildByName("progress").runAction(action1.clone())
    // self.starChest.getChildByName("progress_bg").runAction(action1.clone())
    // self.starChestStar.runAction(action1.clone())
    // self.starChest.getChildByName("num").runAction(action1.clone())

    // let openText = self.starChest.getChildByName("openText")
    // openText.setScale(0)
    // let action2 = cc.Sequence.create(cc.ScaleTo.create(0.2, 1, 1))
    // openText.runAction(action2)

    // let bg = self.starChest.getChildByName("bg")
    // action1 = cc.ScaleBy.create(1, 0.95, 1.05)
    // action2 = cc.ScaleBy.create(1, 1 / 0.95, 1 / 1.05)
    // let bgAction = cc.RepeatForever.create(cc.Sequence.create(action1, action2, action2.clone(), action1.clone()))
    // bg.runAction(bgAction)

    // TODO: update texture, run avtion
}
function getTargetAction(node, callback) {
    let scale = node.getScale()
    return cc.Sequence.create(
        cc.ScaleTo.create(0.3, 0, 0),
        cc.CallFunc.create(() => {
            node.setVisible(false)
            node.setScale(scale)
            callback && callback()
        })
    )
}
MiniHomeScene.prototype.playStarChestChageToCanRewardAnim = function (callback) {
    let self = this
    // let scaleEnd = timeLimitCallbackFunc(() => {
    //     self.openText.setVisible(true)
    //     self.openText.runAction(cc.Sequence.create(cc.ScaleTo.create(0.3, 1, 1), cc.CallFunc.create(() => {
    //         callback && callback()
    //     })))
    // }, 2)
    // self.starChestTitle.runAction(getTargetAction(self.starChestTitle, scaleEnd))
    // self.starChestProcessbar.runAction(getTargetAction(self.starChestProcessbar, scaleEnd))
    let moveEnd = timeLimitCallbackFunc(() => {
        callback && callback()
    }, 2)
    self.starChestProcessbar.runAction(cc.Sequence.create(cc.FadeOut.create(0.1)))
    self.chestIcon.runAction(cc.Sequence.create(cc.MoveBy.create(0.1, 0, -7), cc.CallFunc.create(moveEnd)))
    self.starChestCloud.runAction(cc.Sequence.create(cc.MoveBy.create(0.1, 0, -7), cc.CallFunc.create(moveEnd)))
    self.playStarChestCanRewardAnim()
}
MiniHomeScene.prototype.stopStarChestCanRewardAnim = function () {
    let self = this
    // let bg = self.starChest.getChildByName("bg")
    // bg.stopAllActions()
    // bg.setScale(1)
    // self.chestIcon.stopAllActions()
    self.chestIconAnim.gotoFrameAndPause(0)
    // self.chestIcon.runAction(self.chestIconAnim)
    // self.chestIconAnim.gotoFrameAndPlay(0, 0, false)
}
MiniHomeScene.prototype.playStarChestCanRewardAnim = function () {
    let self = this

    self.stopStarChestCanRewardAnim()
    // let bg = self.starChest.getChildByName("bg")
    // let action1 = cc.ScaleBy.create(1, 0.95, 1.05)
    // let action2 = cc.ScaleBy.create(1, 1 / 0.95, 1 / 1.05)
    // let bgAction = cc.RepeatForever.create(cc.Sequence.create(action1, action2, action2.clone(), action1.clone()))
    // bg.runAction(bgAction)

    // self.chestIcon.runAction(bgAction.clone())
    // self.chestIcon.runAction(self.chestIconAnim)
    self.chestIconAnim.gotoFrameAndPlay(0)

    // let chesticon = self.starChest.getChildByName("chesticon")
    // let jumpAction = cc.Spawn.create(
    //     cc.Sequence.create(
    //         cc.EaseQuinticActionIn.create(cc.MoveBy.create(0.2, 0,  20)),
    //         // cc.EaseSineOut.create(cc.MoveBy.create(0.25, 0, -20))
    //         cc.EaseQuinticActionOut.create(cc.MoveBy.create(0.25, 0, -20))
    //     ),
    //     cc.Sequence.create(
    //         cc.ScaleTo.create(0.2, 0.9, 1),
    //         cc.ScaleTo.create(0.15, 1.05, 1),
    //         cc.ScaleTo.create(0.1, 1, 1)
    //     )
    // )
    // chesticon.runAction(
    //     cc.RepeatForever.create(
    //         cc.Sequence.create(
    //             jumpAction,
    //             jumpAction.clone(),
    //             cc.DelayTime.create(1)
    //         )
    //     )
    // )
    if (self.canOpenChestBubble == undefined){
        self.canOpenChestBubble = 0;
        var success = function(){
            var node = cc.CSLoader.createNode("cocos/get_treasure1_bubblebox_prompt3.csb");
            self.addChild(node, MiniHomeSceneLayerDef.kChestBubble);
            var p = self.starChest.getPosition();
            node.setPosition(cc.pSub(p, cc.p(0, 10)));
            node.getChildByName("txt_content").width = 200;
            node.getChildByName("txt_content").height += 10;
            node.getChildByName("txt_content").y -= 5; 
            node.getChildByName("txt_content").setString(getText("starchest.bubble.text2"));
            node.runAction(cc.repeatForever(cc.sequence(cc.moveBy(1, cc.p(0, 10)), cc.moveBy(1, cc.p(0, -10)))));
            self.canOpenChestBubble = node;
        }
        preloadWithLoading(["packed/GetTreasureBubbleboxPrompt.pack"], success, function () {
            Toast.make(getText("error.tip.load_res_error"))
        }, function () {
            Toast.make(getText("error.tip.load_canceled"))
        })
    }else if (self.canOpenChestBubble != 0){
        self.canOpenChestBubble.setVisible(true);
    }
}
MiniHomeScene.prototype.showStarChestRewardPreview = function (callback) {
    let taskChestPreview = require("clover/panel/component/taskpanel/TaskChestPreview")
    let rewards = UserManager.getInstance().getCurrentStarChestRewards()
    // let column = Math.ceil($len(rewards) / 3)
    // let preview = taskChestPreview.create(rewards, 2, null, null, false)
    let preview = taskChestPreview.create(rewards, 2, getText("starchest.bubble.text1"), null, false)
    // let preview = taskChestPreview.create(table(), 0, "教堂导", "texttexttexttexttexttexttexttext", false)
    // preview.x = -this.starChest._contentSize.width / 2 * 0.8
    preview.y = -80
    this.starChest.addChild(preview)
    preview.onClose = function () {
        callback && callback()
    }
    preview.popup(1000)
}

MiniHomeScene.prototype.playHitChestStarAnim = function (callback) {
    let self = this
    let colorStar = self.starChestStar
    let starOldScale = self.starChestStarOriginScale
    colorStar.stopAllActions()
    function onHitStart() {
        colorStar.setScale(0.6 * starOldScale)
        let actionList = table()
        table.insert(actionList, cc.ScaleTo.create(3 / 30, 2 * starOldScale))
        table.insert(actionList, cc.EaseSineIn.create(cc.ScaleTo.create(3 / 30, 1 * starOldScale)))
        table.insert(actionList, cc.CallFunc.create(() => {
            callback && callback()
        }))
        colorStar.runAction(cc.Sequence.create(actionList))
        let light = AnimationCachePool.getInstance().getAnimation("cocos/starFly_star_eff_ani.csb")
        light.setPosition(colorStar.getPosition())
        light.setAnchorPoint(colorStar.getAnchorPoint())
        colorStar.parent.addChild(light)
        light.actionTimeLine.gotoFrameAndPlay(0, false)
        light.actionTimeLine.setLastFrameCallFunc(function () {
            light.actionTimeLine.clearLastFrameCallFunc()
            light.removeFromParent(false)
            AnimationCachePool.getInstance().backAnimationToPool(light)
        })
    }
    onHitStart()
}

let starProcessStartWidth = 14
let starProcessStartFullWidth = 126
MiniHomeScene.prototype.updateStarChestProgress = function (totalStar, playAnim = true) {
    let self = this
    let starConfig = UserManager.getInstance().getStarChestInfo()
    let allStar = starConfig.starCountOpen
    let process = totalStar / allStar
    let width = starProcessStartFullWidth * Math.min(process, 1) + starProcessStartWidth
    self.starChestProgress.setContentSize(width, 40)
    self.starChestProgressLabel.setString(`${totalStar}/${allStar}`)
    if (process >= 1 && playAnim) {
        self.playStarChestChageToCanRewardAnim()
    }
}
MiniHomeScene.prototype.updateStarBallAfterPassLevel = function () {
    let self = this
    if (self.infoBanner && type(self.infoBanner.updateStarBallAfterPassLevel) === "function") {
        self.infoBanner.updateStarBallAfterPassLevel()
    }
}

MiniHomeScene.prototype.playChageIslandAnim = function (callback) {
    let self = this
    
    let alltime = 1
    let executeTime = 0
    let changeTime = alltime / 4 * 3
    let island2AppearTime = changeTime
    let island1DisAppearTime = changeTime + 0.1
    let starAnimFlag = false
    //  更新按钮
    if (self.unlockIslandTxt) {
        self.oldScore.setVisible(true);
        self.newScore.setVisible(true);
        self.startBtnLeftStr.setVisible(true);
        self.startBtnRightStr.setVisible(true);
        self.unlockIslandTxt.removeFromParent(true);
    }
    let topIslandConfig = UserManager.getInstance().getTopIslandConfig()
    let imgPath = IslandsManager.getInstance().getIslandRes(topIslandConfig).island
    preloadWithLoading(imgPath, () => {
        self.isBusy = true
        let nextIslandNode2 = cc.Sprite.createWithSpriteFrameName(imgPath)
        nextIslandNode2.scale = self.islandNode.scale
        nextIslandNode2.setPosition(self.islandNode.getPosition())
        self.addChild(nextIslandNode2, MiniHomeSceneLayerDef.kIslands)
        if (self.extraAnimNode) {
            self.extraAnimNode.runAction(cc.Sequence.create(cc.FadeOut.create(0.1), cc.CallFunc.create(() => {
                self.extraAnimNode.setVisible(false)
            })))
        }
        quickBuildUIBUtton(nextIslandNode2, handler(self, self.showIslandWord))
        let starAnimNode = cc.CSLoader.createNode("cocos/island_anim_starani.csb")
        let starAnim = cc.CSLoader.createTimeline("cocos/island_anim_starani.csb")
        self.addChild(starAnimNode)
        starAnimNode.runAction(starAnim)
        starAnim.gotoFrameAndPlay(0, 0)
        starAnimNode.setPosition(self.islandNode.getPosition())
        starAnimNode.setVisible(false)
        nextIslandNode2.setVisible(false)
        // nextIslandNode2.setRangeRate(1)

        let onFinish = timeLimitCallbackFunc(() => {
            self.isBusy = false
            callback && callback()
            if (self.islandNode){
                self.islandNode.removeFromParent(true)
            }else{
                cc.error("MiniHomeScene playChageIslandAnim self.islandNode 为空 executeTime,alltime",executeTime,alltime);
            }
            self.islandNode = nextIslandNode2
        }, 2)
        self.timeId = cc.director.getScheduler().scheduleScriptFunc((dt) => {
            executeTime += dt
            if (executeTime >=  alltime) {
                cc.director.getScheduler().unscheduleScriptEntry(self.timeId)
                self.timeId = null
                onFinish()
            }else {
                // self.islandNode.setHue(0, 0, 1, changeTime/(changeTime-executeTime + 0.001), 1)
                self.islandNode.setOpacity(Math.max(Math.floor(255 * (changeTime - executeTime) / 2), 0))
                if (executeTime >= island2AppearTime) {
                    if (executeTime <= island1DisAppearTime) {
                        self.islandNode.setOpacity(Math.max(Math.floor(255 * (island1DisAppearTime - executeTime) / (island1DisAppearTime - changeTime)), 0))
                    }else {
                        self.islandNode.setVisible(false)
                    }
                    nextIslandNode2.setVisible(true)
                    // nextIslandNode2.setHue(0, 0, 1, (alltime - island2AppearTime) / (executeTime - island2AppearTime), 1)
                    nextIslandNode2.setOpacity(Math.max(255 * executeTime / (alltime - island2AppearTime), 255))
                    // if (executeTime >= (alltime + island2AppearTime) / 2 && !starAnimFlag) {
                    if (executeTime >= island2AppearTime && !starAnimFlag) {
                        starAnimNode.setVisible(true)
                        starAnimNode.runAction(starAnim)
                        starAnim.gotoFrameAndPlay(0, false)
                        starAnim.setLastFrameCallFunc(() => {
                            starAnim.clearLastFrameCallFunc()
                            starAnimNode.removeFromParent(true)
                            onFinish()
                        })
                        starAnimFlag = true
                    }
                }
            }
        }, 0, false)
    }, null, null, false)
}
MiniHomeScene.prototype.initUpdateTimer = function () {
    let self = this
    self.updateListeners = []
    self.updateTimers = cc.director.getScheduler().scheduleScriptFunc(handler(self, self.batchLoadRedDotData), 5 * 60)
}
// 批量获取服务器红点数据
MiniHomeScene.prototype.batchLoadRedDotData = function () {
    let self = this

}
MiniHomeScene.prototype.addUpdateListener = function (callback) {
    let self = this
    if (self.updateListeners.indexOf(callback) > -1) {
        return
    }
    self.updateListeners.push(callback)
}
MiniHomeScene.prototype.removeUpdateListener = function (callback) {
    let self = this
    let index = self.updateListeners.indexOf(callback)
    if (index > -1) {
        self.updateListeners.slice(index, 1)
    }
}
MiniHomeScene.prototype.updateNode = function () {

}

/**
 * 添加C位节点
 */
MiniHomeScene.prototype.addCPosNode = function(node) {
    if (this.cPosNode) {
        console.warn("Failed to call [addCPosNode], cPosNode exists in MiniHomeScene already.");
        return false;
    }

    this.cPosNode = node;
    this.cPosNode.setPosition(72, this.startBtn.y)
    this.addChild(node, MiniHomeSceneLayerDef.kPosC)
}

/**
 * 移除C位节点
 */
MiniHomeScene.prototype.removeCPosNode = function() {
    if (this.cPosNode) {
        this.cPosNode.removeFromParent(true);
        this.cPosNode = null;
    }
}

// pvp检查过期奖励
MiniHomeScene.prototype.pvpCheckRewardExpire = function(){
    var onSuccess = function(evt){
        var data = evt.data.rewards;
        var rewards = new Array();
        for(var i = 1; i < data.length; i++){
            var has = false;
            for(var j = 0; j < rewards.length; j++){
                if (data[i].itemId == rewards[j].itemId){
                    has = true;
                    rewards[j].num += data[i].num;
                    break;
                }
            }
            if (!has){
                rewards.push({itemId:data[i].itemId, num:data[i].num});
            }
        }
        if (rewards.length > 0){
            var GetRewardsPanel = require("clover/panel/GetRewardsPanel");
            GetRewardsPanel.show(ContinueCheckName.kShareReward, rewards, true, null, true);
        }
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = FriendPvpCheckRewardExpireHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}

MiniHomeScene.prototype.adCheckCondition = function(){
    var onSuccess = function(evt){
        MetaManager.getInstance().gridAdConfig.videoToday = evt.data.videoToday;
        MetaManager.getInstance().gridAdConfig.pay30day = evt.data.pay30day;
        MetaManager.getInstance().interstitialAdConfig.videoToday = evt.data.videoToday;
        MetaManager.getInstance().interstitialAdConfig.pay30day = evt.data.pay30day;
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = GetGridBannerConditionHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();

    var onSuccess = function(evt){
        MetaManager.getInstance().interstitialAdConfig.adToday = evt.data.interAdCnt;
    }
    var onFail = function(evt){
        cc.error(evt);
    }
    var http = GetInterAdHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}
MiniHomeScene.prototype.cleanSchedulerInterstitialAd = function(){
    cc.log("insertAD cleanScheduler")
    let self = this
    if (self._schedulerId_interstitial_ad){
        cc.director.getScheduler().unscheduleScriptEntry(self._schedulerId_interstitial_ad)
    }
    self._schedulerId_interstitial_ad = null
}
// 胜利过关后回首页显示插屏广告
MiniHomeScene.prototype.checkInterstitialAd = function(callback){
    cc.log("!!!!!!!!!!!!!!!!!!!!!checkInterstitialAd!!!!!!!!!!!!!!!!!!!!!")
    var self = this;
    var adName = "inter_levelsucceed";
    let snsProxy = require("clover/sns/SnsProxy").getInstance();

    // 成功过关后才会显示插屏广告
    if (!snsProxy.getNeedShowInterstitialAdName(adName)){
        return false;
    }

    GoldTurnLogic.getInstance().pauseIconTask = true
    let cnt = 0
    let cb = ()=>{
        if (cnt > 0){
            cc.log("insertAD 只处理一次 callback")
            return
        }
        cnt ++
        callback && callback()
    }

    let before_load_time = new Date().getTime()
    cc.log("insertAD before_load_time ",before_load_time)
    self._schedulerId_interstitial_ad = cc.director.getScheduler().scheduleScriptFunc(function () { 
        let offset = new Date().getTime() - before_load_time
        if (offset > 3000){
            // 上报错误
            // let errMsg = "[TimeOut] offset="+offset;
            // window.logCenter && logCenter.error(new Error(errMsg), 'InterstitialAdError');
            DCAssist.userTrack("inter_ad", "timeout");
            cc.log("insertAD 超时处理 offset ",offset)
            self.cleanSchedulerInterstitialAd()
            cb()
        }
        cc.log("insertAD 加载中 offset ",offset)
    }, 0.1, false)
    var onSuccess = function(evt){
        var startLevelCnt = evt.data.startLevelCnt;
        var adUnitId = MetaManager.getInstance().canShowInterstitialAd(adName, startLevelCnt);
        // adUnitId = "90248940cd0761a46a081fd76eefce66" //90248940cd0761a46a081fd76eefce66 adunit-bea523ca5a44d606
        cc.log("checkInterstitialAd adUnitId", adUnitId);
        if (adUnitId){
            snsProxy.showInterstitialAd(adUnitId, adName, cb, false ,before_load_time)
            .then(()=> {
                cc.log("insertAD showInterstitialAd 外部 ")
            },(err)=>{
                if (err && err.errMsg){
                    // Toast.make(err.errMsg)
                }else{
                    // Toast.make(getText("video.ad.error"));
                }
            })
            .catch(err=> {
                // Toast.make(getText("video.ad.error"));
            })
        }else{
            cb();
        }
    }
    var onFail = function(evt){
        cc.error(evt);
        cb();
    }
    var http = GetInterAdHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
    return true;
}

// 打关出来是否显示宝船的气泡动画 status4已抽奖未领取的打关出来不会显示气泡 显示气泡后不需要后续的弹出框
// 取消icon暂停倒计时任务
MiniHomeScene.prototype.checkGoldTurnShipAnim = function(callback){
    cc.log("!!!!!!!!!!!!!!!!!!!!!checkGoldTurnShipAnim!!!!!!!!!!!!!!!!!!!!!")
    var self = this;
    let logic = GoldTurnLogic.getInstance();
    let info = logic.info;
    let now = Localhost.time();
    logic.pauseIconTask = false;
    logic.addUpdateIconCb(null);
    if (logic.isShowingShip && logic.checkReachShowBubbleLevelTimes()){
        if (info && (info.status == 2 || info.status == 3)){
            logic.clearLevelTimes();
            logic.showBubble();
            if (callback){
                let waitTime = logic.adPropsConfig["ad_gamble_icontips_wait"] || 3000;
                setTimeout(function(){
                    callback();
                }, waitTime)
            }
            return true;
        }
    }else if (info && now >= info.endTime.second){
        console.log(now >= info.endTime.second, now, info.endTime.second);
        if (callback){
            logic.addUpdateIconCb(callback);
        }
        return true;
    }else if (!info){
        return false;
    }
    return false;
}

// 过关后回首页可能需要先看插屏广告，所以把动画延后播放
MiniHomeScene.prototype.onEnterTransitionDidFinish = function(){
    var self = this;
    self.startLevelLogic = null
    dc4UserLoad(200);
    let callback = function(){
        BaseHomeScene.prototype.onEnterTransitionDidFinish.call(self);
    }
    let gotoCheckInterstitialAd = function(){
        if (!self.checkInterstitialAd(callback)){
            callback();
        }
    }
    gotoCheckInterstitialAd();
}

// 检查是否有上次未领取的星星抽奖奖励
MiniHomeScene.prototype.checkLastStarDrawReward = function(){
    var onRewardSuccess = function(evt){
        if (!evt.data.reward && !evt.data.rewards){
            return;
        }
        var userInstance = cc.UserDefault.getInstance();
        var dcCacheData = userInstance.getStringForKey("stardraw_dc_cache_data", "0");
        var drawStatus = null;
        if (!string.isEmpty(dcCacheData) && !dcCacheData == "0"){
            dcCacheData = JSON.parse(dcCacheData);
            drawStatus = dcCacheData.drawStatus;
            var drawType = dcCacheData.drawType;
            var dType = dcCacheData.dType;
            var times = dcCacheData.times;
            var starRewardId = dcCacheData.starRewardId;
            var star1 = dcCacheData.star1;
            var stars = dcCacheData.stars;
            var contribute = dcCacheData.contribute;
            const session = dcCacheData.session;
            const click_type = dcCacheData.click_type;
            if (drawType == 1 || drawType == 3){
                DCAssist.userTrack("newchest", "ad_gacha_finish", {num:times, star1:star1, stars:stars, reward:starRewardId, type:dType, sub_id:contribute});
            }else if (drawType == 2 || drawType == 4 || drawType == 6){
                DCAssist.userTrack("newchest", "common_gacha_result", {session,click_type,num:times, star1:star1, stars:stars, reward:starRewardId, type:dType, sub_id:contribute});
            }else if (drawType == 5){
                DCAssist.userTrack("newchest", "share_gacha_result", {num:times, star1:star1, stars:stars, reward:starRewardId, type:dType, sub_id:contribute});
            }
        }

        //
        let rewardData = evt.data;
        let rewards = new Array();
        if(rewardData.reward) {
            rewards.push(rewardData.reward);
        }else if(rewardData.rewards) {
            rewards = rewardData.rewards;
        }
        var moduleName = null;
        if (drawStatus == 1) {
            moduleName = ModuleName.NEW_CHEST_SMALL;
        } else {
            moduleName = ModuleName.NEW_CHEST_BIG;
        }

        let canDc = true;
        if(rewardData.reward) {
            //单个奖励
            const itemId = rewards[0].itemId;
            if (itemId == 31) {
                // 现金没有飞入动画
                Toast.make(getText("new_chest_tip_getmoney"));
                canDc = false;
            }
        }

        if(canDc) {
            for(let i = 0;i< rewards.length;i++){
                const reward = rewards[i];
                if (reward) {
                    //此时道具数量已加上
                    UserProp.getInstance().dcRewardProp(reward.itemId, reward.num, moduleName);
                }
            }
        }
        //
        ActivityGetRewardsPanel.show({
            type: 1,
            rewardList: rewards,
            tobagAni: true,
            title: `normal`,
            closeCb: () => {
            }
        })
    }
    var onRewardFail = function(evt){
        Toast.make(getText("error.tip.-1"));
    }
    var http = ShowStarRewardDrawHttp.new();
    http.addEventListener(Events.kComplete, onRewardSuccess);
    http.addEventListener(Events.kError, onRewardFail);
    http.addEventListener(Events.kCancel, onRewardFail);
    http.load();
}

// 微信游戏圈礼包检查
MiniHomeScene.prototype.checkWechatGift = function(){
    let self = this
    if (UserManager.getInstance().wxGifts.length > 0){
        let goodId = UserManager.getInstance().wxGifts[0]
        if (goodId){
            console.log('[gift] goodId', goodId)
            let rewards = []
            let name = ""
            let goodCfg = MetaManager.getInstance().goods[goodId]
            console.log('[gift] goodCfg', goodCfg)
            if (goodCfg && goodCfg.items){
                goodCfg.items.forEach(item=>{
                    if (item){
                        rewards.push(item)
                    }
                })
                name = goodCfg.remark
            }
            console.log('[gift] rewards', rewards)
            if (rewards.length > 0){
                let GetRewardsNormalPanel = require("clover/panel/GetRewardsNormalPanel")
                GetRewardsNormalPanel.show({
                    title:"恭喜获得\n" + name,
                    titleAlignment:cc.TEXT_ALIGNMENT_CENTER,
                    desc:"击任意位置即可领取",
                    add_model: ModuleName.WX_GIFT,
                    rewardList: rewards,
                    closeCb:()=>{
                        self.checkWechatGift()
                    }
                })
            }
            UserManager.getInstance().wxGifts.splice(0, 1)
        }
    }
}

module.exports = MiniHomeScene
